import React from "react";

interface BackIconProps {
  width?: number;
  height?: number;
  backgroundColor?: string;
  strokeColor?: string;
}

const BackIcon: React.FC<BackIconProps> = ({ width = 32, height = 32, backgroundColor = "#3E497A", strokeColor = "#3F4778" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="24" height="24" rx="12" fill={backgroundColor} fillOpacity="0.05" />
      <path
        d="M14 17L9.40683 12.8838C8.86439 12.3977 8.86439 11.6023 9.40683 11.1162L14 7"
        stroke={strokeColor}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackIcon;
